'use client';

import {
  AggregateLandModel,
  AggregateLandService,
  LandTiers,
} from '../../services/AggregateLand/AggregateLandService';
import { useCallback, useContext, useEffect } from 'react';
import { useAccount } from "wagmi"
import { sepoliaChainId, shibariumChainId } from '../../constants/index';
import { mainNetworkChainId } from '../../constants/index';
import { puppyNetChainId } from '../../constants/index';
import { useState } from 'react';
import { MintMultiModal } from '../Map/MintModal/MintModal';
import React from "react"
import ShiberseLoader from '../Loader/loader';
import { LandPurchaseContext } from '../../contexts/land-purchase-context';


interface CryptoMintBtnProps {
  tier: LandTiers;
  quantity: number;
  onOpen: (() => void) | undefined;
}

const CryptoMintBtn: React.FC<CryptoMintBtnProps> = ({ tier, quantity, onOpen }) => {
  const [showMintModal, setShowMintModal] = useState(false);
  const { address, chain } = useAccount();
  const [selectedInfo, setSelectedInfo] = useState<Array<AggregateLandModel>>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mintType, setMintType] = useState<'eth' | 'shib' | 'weth'>('shib');
  const { landQuantity, landType } = useContext(LandPurchaseContext);

  useEffect(() => {
    if (landQuantity || landType) {
      setIsLoading(false);
    }
  }, [landQuantity, landType]);

  const toggleMintModal = useCallback(() => {
    setShowMintModal((prev) => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setSelectedInfo([]);
    setShowMintModal(false);
  }, []);



  const handleMint = async (type: 'eth' | 'shib' | 'weth') => {
    setMintType(type);
    await mint();
  };


  const mint = async () => {
    if (!address) {
      onOpen?.();
      return;
    }

    try {
      setIsLoading(true);
      const contigousLands = await AggregateLandService.fetchAggregateLands(tier, quantity);
      setSelectedInfo(contigousLands);
      setShowMintModal(contigousLands.length > 0);
    } catch (error) {
      console.error("Error fetching aggregate lands:", error);
      alert("An error occurred while aggregating lands. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      {isLoading ? (
        <div className='flex justify-center items-center h-12 w-full'><ShiberseLoader /></div>
      ) : (
        <div className="flex flex-col space-y-4 w-full">
          <button
            onClick={() => chain?.id == mainNetworkChainId || chain?.id == sepoliaChainId ? handleMint('eth') : handleMint('weth')}
            className="flex h-12 w-full items-center justify-center self-center rounded-3xl border px-8 py-2 text-center text-sm font-semibold text-white bg-[#F38F2E] focus:outline-none"
          >
            Mint with ETH
          </button>
          <button
            onClick={() => handleMint('shib')}
            className="flex h-12 w-full items-center justify-center self-center rounded-3xl border px-8 py-2 text-center text-sm font-semibold text-white bg-[#F38F2E] focus:outline-none"
          >
            Mint with SHIB
          </button>
        </div>
      )}
      {showMintModal && selectedInfo.length > 0 && (
        <MintMultiModal
          isOpen={showMintModal}
          onDismiss={toggleMintModal}
          selectedInfo={selectedInfo}
          handleCloseAction={handleClose}
          mintType={mintType}
        />
      )}
    </>
  );
};

export default CryptoMintBtn;
